<template>
    <div class="full-container">
        <h1 class="top-text">Plan Price Discounts</h1>
        <div class="window">
            <div id="top-row">
                <h2 class="top-description">Configure discounts applied to your plan's monthly price.</h2>
            </div>
            <div class="body">
                <div class="membership-discounts-section">
                    <h3 class="description">Plan Price Discounts</h3>
                    <div class="row-holder">
                        <DiscountRow
                            v-for="discount in monthlyDiscounts"
                            :key="discount.id"
                            :otherDiscount="discount"
                            @remove="removeDiscount(discount.id)"
                        />
                    </div>
                    <div class="btn-container">
                        <button class="add-btn hover-grow" onmouseup="this.blur();" @click="ShowMembershipDiscountModal">+ Create New Discount</button>
                    </div>
                </div>
            </div>
        </div>
        <SaveChangesButton v-if="mode === 'view'" @btnPressed="GoToOverview()"></SaveChangesButton>
        <transition name="fade" mode="out-in">
            <div class="modal-overlay" v-if="showMembershipDiscountModal" @click.self="RemoveMembershipDiscountModal">
                <AddDiscountModal
                    restrict-type="monthly"
                    @click.stop
                    @exitModal="RemoveMembershipDiscountModal"
                    @addDiscount="AddMembershipDiscount($event)"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { GoToComponent } from '../utils/functions';
import SaveChangesButton from './SaveChangesButton.vue';
import DiscountRow from './DiscountRow.vue';
import AddDiscountModal from './modals/AddDiscountModal.vue';

export default {
    components: {
        SaveChangesButton,
        DiscountRow,
        AddDiscountModal,
    },
    props: {
        mode: String,
    },
    data() {
        return {
            showMembershipDiscountModal: false,
        };
    },
    methods: {
        ...mapActions(['setMonthlyDiscounts']),
        GoToOverview() {
            GoToComponent(this, 'overview');
        },
        ShowMembershipDiscountModal() {
            this.showMembershipDiscountModal = true;
        },
        RemoveMembershipDiscountModal() {
            this.showMembershipDiscountModal = false;
        },
        AddMembershipDiscount(payload) {
            const amount = payload.discountAmount;
            const nextId = this.monthlyDiscounts.length
                ? this.monthlyDiscounts[this.monthlyDiscounts.length - 1].id + 1
                : 1;
            const newDiscount = {
                ...payload,
                id: nextId,
                dollarsOff: amount,
                isActive: true,
                isSenior: false,
                isMultiplePatient: false,
            };
            delete newDiscount.discountAmount;
            delete newDiscount.discountType;
            this.setMonthlyDiscounts([...this.monthlyDiscounts, newDiscount]);
        },
        removeDiscount(discountId) {
            const updated = this.monthlyDiscounts.filter(d => d.id !== discountId);
            this.setMonthlyDiscounts(updated);
        },
    },
    computed: {
        monthlyDiscounts() {
            return this.$store.state.monthlyDiscounts;
        },
    },
};
</script>

<style scoped>
.top-text {
    margin: 0;
    margin-top: 1%;
    margin-bottom: 1%;
    color: var(--font-color-teal);
}

.full-container {
    width: 100%;
    height: 100%;
    max-height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0;
}

.window {
    width: 95%;
    max-height: 100%;
    height: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border-radius: 20px;
}

#top-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

#top-row h2 {
    margin-left: 2em;
    margin-right: 2em;
    font-size: 1.3em;
}

.body {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 1.5%;
}

.membership-discounts-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1em;
    padding-bottom: 1em;
}

.membership-discounts-section .row-holder {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.membership-discounts-section .description {
    color: var(--color-dark-gray);
    margin-bottom: 0.5em;
}

.membership-discounts-section .btn-container {
    margin-top: 0.5em;
    display: flex;
    justify-content: center;
    width: 97%;
    margin-bottom: 0.5em;
}

.membership-discounts-section .add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid var(--color-light-blue);
    border-radius: 40px;
    height: 4em;
    width: 40%;
    max-height: 55px;
    background-color: white;
    color: var(--color-bright-blue);
    font-size: 1.5em;
    font-weight: 600;
    padding-right: 0.7em;
    padding-left: 0.7em;
    cursor: pointer;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}
</style>
